<template>
<div class="chapter">
<div class="inner_page">
<a id="p3"></a>
<p class="sink"> </p>
<div class="third">
<hr class="paired"/>
<hr class="thick pairedtop paired"/>
</div>
<h1 class="chaptertitle parttitle allcaps pairedtop largest">Part I</h1>
<p class="center ">All good things are wild and free.</p>
<p class="center ">—Henry David Thoreau</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c001.vue?3f50398e